const getNumericBalance = (balance: number | string): number => {
  if (typeof balance === 'string') {
    const parsed = parseFloat(balance);
    return isNaN(parsed) ? 0 : parsed;
  }
  return balance;
};

export default getNumericBalance;
